import axiosInstance from 'api/axiosInstance';
import { URL_CANTRACK_CREATE_KEYWORD } from 'constants/urls';
import { KeywordPayload } from './types';

/**
 * Creates a new keyword.
 * @param keywordData - The keyword fields to create
 * @returns The API response data
 * @throws Re-throws any Axios error after logging
 */
const createKeyword = async (keywordData: KeywordPayload) => {
  try {
    const { data } = await axiosInstance({
      method: 'POST',
      url: URL_CANTRACK_CREATE_KEYWORD,
      data: { payload: keywordData },
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    });
    return data;
  } catch (error) {
    console.error('[createKeyword] Failed:', error);
    throw error;
  }
};

export default createKeyword;
